import React from 'react';
import { ConnectedIcon, UnpairedIcon } from '../Common/Icons';
import { useSelector } from 'react-redux';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';

const NetworkingDetailsBlock = ({ device, deviceStatus }) => {
  const trans = useSelector(translator);
  const labels = {
    wifi: {
      label1: device?.device_primary_wan?.replace(/wifi|WiFi|WIFI|wi-fi/gi, 'Wi-Fi'),
      label2: [
        device?.device_wifi_ssid || '-',
        device.device_operating_frequency_band || '-',
        device.device_signal_strength ? `${device.device_signal_strength} ${trans('DBM')}` : '-',
      ],
    },
    ethernet: {
      label1: device?.device_primary_wan,
      label2: [trans('10/100MBPS')],
    },
    lte: {
      label1: device?.device_primary_wan,
      label2: [
        `${trans('IMEI_U')} : ${device?.device_imei || '-'}`,
        `${trans('SIM_U')} : ${device?.device_imsi || '-'}`,
        device?.device_carrier_id_name || '-',
      ],
    },
  };
  const { label1, label2 } = labels[device?.device_primary_wan?.toLowerCase()] || {
    label1: '-',
    label2: '-',
  };
  const isConnected = deviceStatus === 'connected';

  return (
    <div className="networking-details-block-container">
      <div className="networking-details-block">
        <div className="networking-details-block-1">
          <div className="label-container-1">
            <span className="label-1">{label1}:</span>
          </div>
          <div className="label-container-2">
            {Array.isArray(label2) ? (
              label2.map((item, index) => (
                <span key={index} className="label-2">
                  {item}
                </span>
              ))
            ) : (
              <span className="label-2">{label2}</span>
            )}
          </div>
        </div>
        <div className="connectedicon-container">
          {isConnected ? (
            <ConnectedIcon label={trans('CONNECTED')} />
          ) : (
            <UnpairedIcon label={trans('DISCONNECTED')} />
          )}
        </div>
      </div>
    </div>
  );
};

export default NetworkingDetailsBlock;
